<template>
  <tbody>
    <tr>
      <td rowspan="2" class="hidden-xs">
        <img v-if="hasImages" :src="'/images/articles/' + baseArticle.images[0].path" height="50px">
      </td>
      <td>
        <div v-if="unitIsSqm"> {{ displayName }} {{ article.count }}m²</div>
        <div v-if="unitIsPc">{{ article.count }}x {{ displayName }}</div>
        <small v-show="article.inclusive > 0">
          ({{ article.inclusive }} {{ (article.inclusive_unit == 'pc') ? $t('labels.per_unit') : '/&#13217;' }} incl.)
        </small><br>
        {{ $filters.formatMoney(pricePerUnit) }} / {{ (unitIsPc) ? $t('labels.per_unit') : '&#13217;' }}
      </td>
      <td class="text-right">{{ $filters.formatMoney(price) }}</td>
      <td v-if="!basket.net_value_only" class="text-right">
        {{ $filters.formatMoney(priceVat) }}
      </td>
      <td v-if="!basket.net_value_only" class="text-right">
        {{ $filters.formatMoney(priceGross) }}
      </td>
    </tr>
  </tbody>
</template>

<script setup>
import { UNIT_PC, UNIT_SQM } from '@/constants'
import { useMainStore } from '@/store'
import { addLateDeliverySurcharge } from '@/utils/helper'
import { computed } from 'vue'

const store = useMainStore()
// define passed props
const props = defineProps({
  article: {
    type: Object,
    required: true,
  },
})
// define computed props
const locale = computed(() => store.settings.locale)
const basket = computed(() => store.print.basket)
const earlyBirdMode = computed(() => store.tmp.early_bird_mode)
const lateDelivery = computed(() => store.tmp.late_delivery)

const baseArticle = computed(() => {
  if (props.article.booth_refinement_id) {
    return props.article
  }
  
  return props.article.article
})

const displayName = computed(() => {
  return (locale.value === 'en') ? baseArticle.value.name_en : baseArticle.value.name
})

const unitIsPc = computed(() => {
  return props.article.unit === UNIT_PC
})

const unitIsSqm = computed(() => {
  return props.article.unit === UNIT_SQM
})

const hasImages = computed(() => {
  return baseArticle.value.images !== null
    && baseArticle.value.images.length > 0
    && baseArticle.value.images[0].path !== null
})

const pricePerUnit = computed(() => {
  return (earlyBirdMode.value)
    ? addLateDeliverySurcharge(props.article.exhibition_prices.price_net, lateDelivery.value)
    : props.article.exhibition_prices.price_net
})

const price = computed(() => {
  return correctedAmount.value * pricePerUnit.value
})

const priceGross = computed(() => {
  return price.value * (1 + (basket.value.getVatRate() / 100))
})

const priceVat = computed(() => {
  return priceGross.value - price.value
})

const correctedAmount = computed(() => {
  return props.article.count - ((props.article.inclusive) ? props.article.inclusive : 0)
})
</script>